import {
  EnvironmentProviders,
  ErrorHandler,
  Provider,
  inject,
  provideEnvironmentInitializer,
} from '@angular/core';
import { I18nPluralPipe } from '@angular/common';
import {
  BdCurrentUserService,
  BdDash0TrackingService,
  BdHubspotTrackingService,
  BdUserErrorHandler,
  TRACKING_SERVICE,
} from '@bindoc-projects/user-lib/data';
import { BdPageTitleService } from '@bindoc-projects/util-lib/data';
import { DialogService } from 'primeng/dynamicdialog';

/**
 * Root providers for the forced-consent app profile (formerly
 * `BdAppStarterForcedConsentModule`).
 */
export function provideAppStarterForcedConsent(
  securityProviders: Array<Provider | EnvironmentProviders>,
): Array<Provider | EnvironmentProviders> {
  return [
    ...securityProviders,
    // See `provideAppStarter()` for why this and `DialogService` below are not
    // redundant with `providedIn: 'root'`.
    I18nPluralPipe,
    {
      provide: TRACKING_SERVICE,
      useClass: BdHubspotTrackingService,
      multi: true,
    },
    {
      provide: TRACKING_SERVICE,
      useClass: BdDash0TrackingService,
      multi: true,
    },
    { provide: ErrorHandler, useClass: BdUserErrorHandler },
    DialogService,
    provideEnvironmentInitializer(() => {
      const pageTitleService = inject(BdPageTitleService);
      const currentUserService = inject(BdCurrentUserService);

      pageTitleService.init();
      currentUserService.init();
    }),
  ];
}
